import axios from 'axios';

const externalAxios = axios.create();

export interface Location {
  place_id: number;
  licence: string;
  osm_type: string;
  osm_id: number;
  boundingbox: string[];
  lat: string;
  lon: string;
  display_name: string;
  class: string;
  type: string;
  importance: number;
  icon?: string;
}

export const searchLocation = async (q: string): Promise<Location[]> => {
  const response = await externalAxios.get<Location[]>('https://nominatim.openstreetmap.org/search', {
    params: {
      q,
      format: 'json',
    },
  });

  return response.data;
};
